export default __webpack_public_path__ + "d3fd43777d18cba1ac5e7ff9482bd5c8.woff";